import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button } from 'react-bootstrap'
import GrowthWheelWorks from '../../components/GrowthWheelWorks/GrowthWheelWorks'
import GrowthWheelVisualizer from '../../components/GrowthWheelVisualizer/growth-wheel-visualizer'
import CompetencyAreaCard from '../../components/GrowthWheelComponents/CompetencyAreaCard'
import { setCurrentCompetency, setCurrentCompetencyArea } from '../../redux/growthWheel.slice'
import { RootState } from '../../redux/store'
import { CompetencyArea } from '../../types/GrowthWheel'
import { getCompletedCompetencies, getTotalCompetencies } from '../../utils/growth-wheel-utils'
import AreasOfFocus from '../../components/GrowthWheelComponents/AreasOfFocus'
interface Props {
  userName?: string
  guildName?: string
}
const GrowthWheelDashboard = ({ userName, guildName }: Props) => {
  const dispatch = useDispatch()
  const growthWheelData = useSelector((state: RootState) => state.growthWheel.growthWheelData)
  const isLoading = useSelector((state: RootState) => state.growthWheel.isLoadingGrowthWheel)
  const userCompetencyAreasData = useSelector((state: RootState) => state.growthWheel.userCompetencyAreasData)
  const growthWheelCompleted = useSelector((state: RootState) => state.growthWheel.growthWheelCompleted)

  const handleClickCompetencyArea = (competencyArea: CompetencyArea | null) => {
    dispatch(setCurrentCompetencyArea(competencyArea))
  }

  const ContinueAssessment = () => {
    const firstUncompletedCompetency = userCompetencyAreasData?.flatMap((area) => area.competencies ?? []).find((competency) => !competency.evaluation?.selfLevel)
    if (firstUncompletedCompetency) {
      const currentCompetencyArea = userCompetencyAreasData?.find((area) => area.competencies?.some((competency) => competency.id === firstUncompletedCompetency.id))
      dispatch(setCurrentCompetencyArea(currentCompetencyArea!))
      dispatch(setCurrentCompetency(firstUncompletedCompetency))
    }
  }

  const shoudlDisplayStartAssessment = userCompetencyAreasData?.flatMap((area) => area.competencies ?? []).every((competency) => !competency.evaluation?.selfLevel);

  return (
    <div className="container mb-5 gw-growth-wheel-container">
      <div className="my-5">
        <h1 className='gw-growth-wheel-title'>
          {userName ? `${userName}'s` : ''} Growth Wheel
        </h1>
        {guildName ? (
          <p className="gw-growth-wheel-guild-name">{guildName}</p>
        ) : null}
        <p className="gw-growth-wheel-dashboard-tagline">
          Reflect on your competencies and prepare for meaningful growth conversations.
        </p>
      </div>
      <div className='row'>
        <div className='col-10 col-md-4 gw-visualizer-container'>
          {isLoading ? (
            <div>Loading...</div>
          ) : (<>
            <GrowthWheelVisualizer imageUrl={growthWheelData?.imageUrl || undefined} />
            <GrowthWheelWorks />
          </>
          )}
        </div>
        <div className='col-12 col-md-8 gw-competency-area-cards-container'>
          <div className='gw-competency-area-cards-header'>
            <h3 className='gw-competency-area-cards-header-title'>Competencies</h3>
            {!growthWheelCompleted && <Button onClick={ContinueAssessment}> {shoudlDisplayStartAssessment ? 'Start Assessment' : 'Continue Assessment'}</Button>}
          </div>
          <AreasOfFocus />
          <hr />
          <div className='gw-competency-area-list'>
            {userCompetencyAreasData.map((competencyArea) => (
              <CompetencyAreaCard
                key={competencyArea.id}
                title={competencyArea.name}
                description={competencyArea.description}
                onClick={() => handleClickCompetencyArea(competencyArea)}
                completed={getCompletedCompetencies(competencyArea.competencies ?? [])}
                total={getTotalCompetencies(competencyArea.competencies ?? [])}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default GrowthWheelDashboard